/**
 * @function getFrontendId
 * @description Generates a unique frontend identifier by combining the package name
 *  with frontend name and optional ID
 * @param {string} frontend - The frontend name to include in the generated ID
 * @param {string} [id] - Optional identifier to append to the generated ID
 * @returns {string} The generated frontend identifier in format: "package-name-frontend" or
 *  "package-name-frontend-id"
 *
 * @example
 * // Returns "customer-web-service-frontend"
 * getFrontendId('frontend');
 *
 * @example
 * // Returns "customer-web-service-frontend-123"
 * getFrontendId('frontend', '123');
 */
export default function getFrontendId(frontend, id) {
  if (!id) return `${PACKAGE.name}-${frontend}`;
  return `${PACKAGE.name}-${frontend}-${id}`;
}
